import React from 'react';
import { Link } from 'react-router-dom';

const FAQContactBanner = () => {
  return (
    <section style={{
      background: '#0A1220',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      padding: '80px 5%'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: '1fr 1fr',
          gap: '60px', alignItems: 'center'
        }}>
          {/* Left: text */}
          <div>
            <div style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem', fontWeight: 700,
              color: '#E8521A', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '16px'
            }}>FANT IKKE SVARET?</div>
            <h2 style={{
              fontFamily: 'Syne, sans-serif', fontSize: 'clamp(1.75rem, 3.5vw, 2.75rem)',
              fontWeight: 800, color: '#EEF0F2', letterSpacing: '-0.03em',
              lineHeight: 1.1, margin: 0, marginBottom: '16px'
            }}>Kontakt oss direkte</h2>
            <p style={{
              fontFamily: 'Inter, sans-serif', fontSize: '1rem',
              color: 'rgba(138,149,163,0.7)', lineHeight: 1.7, marginBottom: '32px'
            }}>Vårt supportteam er tilgjengelig mandag til fredag 08:00–20:00. Vi svarer vanligvis innen 2 timer på e-post.</p>
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
              <Link to="/nord-pass-contact-page" style={{
                display: 'inline-flex', alignItems: 'center', gap: '10px',
                padding: '14px 28px', background: '#E8521A',
                fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700,
                color: '#EEF0F2', textDecoration: 'none', letterSpacing: '0.05em',
                textTransform: 'uppercase', transition: 'all 200ms ease'
              }}
                onMouseEnter={(e) => { e.currentTarget.style.background = '#d4461a'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = '#E8521A'; }}
              >SEND MELDING →</Link>
              <a href="tel:+4722000000" style={{
                display: 'inline-flex', alignItems: 'center', gap: '10px',
                padding: '14px 28px',
                border: '1px solid rgba(59,111,212,0.4)',
                fontFamily: 'Syne, sans-serif', fontSize: '0.875rem', fontWeight: 700,
                color: '#3B6FD4', textDecoration: 'none', letterSpacing: '0.05em',
                textTransform: 'uppercase', transition: 'all 200ms ease'
              }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(59,111,212,0.08)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
              >RING OSS</a>
            </div>
          </div>
          {/* Right: contact cards */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {[
              { icon: '✉', label: 'E-post', value: 'support@nordpass.no', sub: 'Svar innen 2 timer', color: '#3B6FD4' },
              { icon: '☎', label: 'Telefon', value: '+47 22 00 00 00', sub: 'Man–Fre 08:00–20:00', color: '#2A9D8F' },
              { icon: '◈', label: 'Live chat', value: 'Chat med oss nå', sub: 'Tilgjengelig i appen', color: '#E8521A' },
            ]?.map((item, i) => (
              <div key={i} style={{
                display: 'flex', alignItems: 'center', gap: '20px',
                padding: '20px 24px',
                border: '1px solid rgba(255,255,255,0.06)',
                background: 'rgba(255,255,255,0.02)',
                transition: 'all 200ms ease'
              }}
                onMouseEnter={(e) => { e.currentTarget.style.borderColor = item?.color + '33'; e.currentTarget.style.background = item?.color + '08'; }}
                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)'; e.currentTarget.style.background = 'rgba(255,255,255,0.02)'; }}
              >
                <div style={{
                  width: '44px', height: '44px', background: item?.color + '15',
                  border: `1px solid ${item?.color}33`,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '1.25rem', color: item?.color, flexShrink: 0
                }}>{item?.icon}</div>
                <div>
                  <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem', color: 'rgba(138,149,163,0.5)', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '2px' }}>{item?.label}</div>
                  <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.9375rem', fontWeight: 700, color: '#EEF0F2' }}>{item?.value}</div>
                  <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: 'rgba(138,149,163,0.5)', marginTop: '2px' }}>{item?.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQContactBanner;
